import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui';
Vue.use(Router)

// const Index = ()=> import('../newPage/index') //关于我们
// const Case = ()=> import('../newPage/case') //成功案列
// const Hzzx = ()=> import('../page/hzzx') //合作咨询
// const Rczp = ()=> import('../page/rczp') //人才招聘
const Index = () => import('../newPage/index') // 走进百师
const Case = () => import('../newPage/case') // 产品矩阵
const Ysal = () => import('../newPage/ysal') // 优势&案例
const Zxns = () => import('../newPage/zxns') // 招贤纳士
const Lxwm = () => import('../newPage/lxwm') // 联系我们
const DynamicState = () => import('../newPage/dynamicState') // 动态列表
const Recruit = () => import('../newPage/recruit') // 招聘
const DeliveryRecord = () => import('../newPage/deliveryHistory') // 投递记录
const JobDetails = () => import('../newPage/jobDetails') // 岗位详情
const Deliver = () => import('../newPage/deliver') // 简历投递
const Workbench = () => import('../layout/workbench.vue') // 工作台首页
const WorkbenchIndex = () => import('../newPage/workbench/components/index.vue') // 工作台首页
const PositionDesign = () => import('../newPage/workbench/components/positionDesign.vue') // 工作台岗位设计
const EditorialPost = () => import('../newPage/workbench/components/editorialPost.vue') // 工作台编辑岗位
const InviteForAJobInfo = () => import('../newPage/workbench/inviteForAJobInfo.vue')
const NewsInformation = () => import('../newPage/workbench/newsInformation.vue')
const ArticleList = () => import('../newPage/workbench/components/articleList.vue')
const CompanyDetails = () => import('../newPage/companyDetails.vue')
const Error = () => import('../newPage/404.vue')
// 移动端页面
// const MobileIndex = () => import('../mobile/index.vue')
const MobileIndex = () => import('../mobile/newIndex.vue')
const MobileCpjz = () => import('../mobile/newCpjz.vue')
const MobileYsal = () => import('../mobile/newYsal.vue')
const MobileLxwm = () => import('../mobile/lxwm.vue')
const MobileQyxq = () => import('../mobile/newQyxq.vue')
const router = new Router({
	mode:'history',
	base: '/',
  routes: [
    {
      path: '/index',
      name: 'Index',
      component:Index,
      meta:{title:'百师联盟教育集团'}
    },
	{
	  path: '/case',
	  name: 'Case',
	  component:Case,
	  meta:{title:'百师联盟教育集团'}
	},
	{
	  path: '/ysal',
	  name: 'Ysal',
	  component:Ysal,
	  meta:{title:'百师联盟教育集团'}
	},
	{
	  path: '/lxwm',
	  name: 'Lxwm',
	  component:Lxwm,
	  meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/zxns',
		name: 'Zxns',
		component:Zxns,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/recruit',
		name: 'Recruit',
		component:Recruit,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/deliveryRecord',
		name: 'DeliveryRecord',
		component:DeliveryRecord,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/jobDetails',
		name: 'JobDetails',
		component:JobDetails,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/deliver',
		name: 'Deliver',
		component:Deliver,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/dynamicState',
		name: 'DynamicState',
		component:DynamicState,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/companyDetails',
		name: 'CompanyDetails',
		component:CompanyDetails,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/workbench',
		name: 'Workbench',
		component:Workbench,
		children: [
			{
				path: '/workbench/inviteForAJobInfo', 
				redirect:'/workbench/inviteForAJobInfo/index', 
				meta:{title:'百师联盟教育集团',name:'招聘信息',menu:true,id:1,icon:'el-icon-notebook-1', userType: 1},
				component: InviteForAJobInfo,
				name:'InviteForAJobInfo',
				children: [
					{path: '/workbench/inviteForAJobInfo/index', component: WorkbenchIndex,name:'Index', meta:{title:'百师联盟教育集团',name:'招聘收集',menu:true,id:1,userType: 1}},
					{path: '/workbench/inviteForAJobInfo/positionDesign', component: PositionDesign,name:'PositionDesign', meta:{title:'百师联盟教育集团',name:'岗位设置',menu:true,id:2,userType: 1}},
					{path: '/workbench/inviteForAJobInfo/editorialPost', component: EditorialPost,name:'EditorialPost', meta:{title:'百师联盟教育集团',name:'岗位编辑',menu:false,id:2,userType: 1}},
				]
			},
			{
				path: '/workbench/newsInformation', 
				redirect:'/workbench/newsInformation/articleList', 
				meta:{title:'百师联盟教育集团',name:'新闻信息',menu:true,id:1,icon:'el-icon-postcard',userType: 2},
				component: NewsInformation,
				name:'NewsInformation',
				children: [
					{path: '/workbench/inviteForAJobInfo/articleList', component: ArticleList,name:'ArticleList', meta:{title:'百师联盟教育集团',name:'文章列表',menu:true,id:1,userType: 2}},
					// {path: '/workbench/inviteForAJobInfo/positionDesign', component: PositionDesign,name:'PositionDesign', meta:{title:'百师联盟教育集团',name:'岗位设置',menu:true,id:2}},
					// {path: '/workbench/inviteForAJobInfo/editorialPost', component: EditorialPost,name:'EditorialPost', meta:{title:'百师联盟教育集团',name:'岗位编辑',menu:false,id:2}},
				]
			}
			// {path: '/workbench/index', component: WorkbenchIndex, meta:{title:'百师联盟教育集团',name:'招聘收集',menu:true,id:1,icon:'el-icon-notebook-1'}},
			// {	
			// 	path: '/workbench/positionDesign', component: PositionDesign, meta:{title:'百师联盟教育集团',name:'岗位设计',menu:true,id:2,icon:'el-icon-brush'},
			// },
			// {path: '/workbench/editorialPost', component: EditorialPost, meta:{title:'百师联盟教育集团',name:'岗位编辑',menu:false,id:2}},
		],
		meta:{title:'百师联盟教育集团',userType: 12}
	},
	{
		path: '/mobileIndex',
		name: 'MobileIndex',
		component:MobileIndex,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/mobileCpjz',
		name: 'MobileCpjz',
		component:MobileCpjz,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/mobileYsal',
		name: 'MobileYsal',
		component:MobileYsal,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/mobileLxwm',
		name: 'MobileLxwm',
		component:MobileLxwm,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/mobileQyxq',
		name: 'MobileQyxq',
		component:MobileQyxq,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path: '/404',
		name: '404',
		component:Error,
		meta:{title:'百师联盟教育集团'}
	},
	{
		path:'/',
		redirect:'/index'
	}
  ]
})
export default router
let whiteList = ["/index", "/case", "/ysal", "/lxwm", "/zxns", "/recruit", "/deliveryRecord", "/jobDetails", "/deliver", "/dynamicState", "/companyDetails", "/404", "/mobileIndex", "/mobileCpjz", "/mobileYsal", "/mobileLxwm", "/mobileQyxq"]; // 白名单
let pc = ["/index", "/case", "/ysal", "/lxwm", "/zxns", "/recruit", "/deliveryRecord", "/jobDetails", "/deliver", "/dynamicState", "/companyDetails"]
let mobile = ["/mobileIndex", "/mobileCpjz", "/mobileYsal", "/mobileLxwm", "/mobileQyxq"]
//路由全局守卫功能
router.beforeEach((to,from,next)=>{
	if (to.path == '/index') {
		if (isMobile()) {
			next({ path: "/mobileIndex" });
		}
	}
	if (to.path == '/case') {
		if (isMobile()) {
			next({ path: "/mobileCpjz" });
		}
	}
	if (to.path == '/ysal') {
		if (isMobile()) {
			next({ path: "/mobileYsal" });
		}
	}
	if (to.path == '/lxwm') {
		if (isMobile()) {
			next({ path: "/mobileLxwm" });
		}
	}
	if (to.path == '/companyDetails') {
		if (isMobile()) {
			next({ path: "/mobileQyxq" });
		}
	}
	if (mobile.indexOf(to.path) > -1) {
		if (!isMobile()) {
			next({ path: "/index" });
		}
	}
	if (!whiteList.includes(to.path)) {
		// 获取用户身份
		let printReportShowQuery = JSON.parse(localStorage.getItem('printReportShowQuery'));
        let userType = printReportShowQuery ? printReportShowQuery.registerType : 0;
		console.log(to,'oooooooooooooooo');
		if (userType == to.meta.userType || to.meta.userType == 12) {
			next()
		} else {
			// next(false);
			next({ path: "/404" });
        	// Message.warning("暂无权限");
		}
	} else {
		next()
	}
	// 根据路由元信息设置文档标题
	window.document.title = to.meta.title
  // 让页面回到顶部
  document.body.scrollTop = document.documentElement.scrollTop = 0;
	// next()
})
function isMobile(){
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	return flag;
}
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js